<template>
    <date-picker
        :minimum-view="minimumView"
        :value="value"
        :full-month-name="true"
        @input="updateSelected"
        :disabled-dates="disabledDates"
        :open-date="openDate"
        :format="format"
        input-class="form-control border border-dark"
        calendar-class="bg-skyblue" >
    </date-picker>
</template>

<script>
import moment from "moment";
import DatePicker from "vuejs-datepicker";
//import Utils from "../mixins/UtilsMixin"; // Pointless to include when not using!

export default {
    components : {"date-picker" : DatePicker},

    //mixins : [Utils],

    props : {

        defaultDate : {
            type : Date,
            default : new Date()
        },

        disabledDates : {
            type : Object,
            default : {
                from : null,
                to : null,
            }
        },

        minimumView : {
            type : String,
            default : "month",
        },

        format : {
            type : String,
            default : "MMMM yyyy"
        }

    },

    data() {
        return {
            value : this.defaultDate
        };
    },

    computed : {

        openDate() {
            return this.disabledDates.from || this.disabledDates.to || new Date();
        }

    },

    methods : {

        updateSelected(val) {
            this.value = moment(val).toDate();
            this.$emit("input", this.value);
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/common/Picker.vue